import { createVNode as i, mergeProps as a } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RotateRightOutlined.js";
import l from "../components/PfIcon.js";
const t = (e, o) => {
  const r = {
    ...e,
    ...o.attrs
  };
  return i(l, a(r, {
    icon: n
  }), null);
};
t.displayName = "RotateRightOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
